import { Link } from 'react-router-dom';
import { PHONES, STATES_SHORT } from '../../lib/site';
import { SocialLinks } from './SocialLinks';
import StatesMarquee from '../StatesMarquee';

const LINKS = [
  ['Medicare', '/medicare'],
  ['Insurance', '/insurance'],
  ['Retirement Planning', '/retirement-planning'],
  ['About', '/about'],
  ['Why Choose Us', '/why-choose-us'],
  ['Contact', '/contact'],
];

export const SiteFooter = () => (
  <footer data-testid="site-footer" className="relative z-10 bg-[#040711]/95 border-t border-white/10 pt-16">
    <div className="max-w-7xl mx-auto px-5 lg:px-8 grid gap-12 md:grid-cols-4 pb-12">
      <div className="md:col-span-1 space-y-4">
        <div className="inline-block bg-white rounded-xl px-3 py-2">
          <img src="/assets/zivae-logo.jpg" alt="Zivae Financial" className="h-14 w-auto no-zoom" />
        </div>
        <p className="text-sm text-slate-400 leading-relaxed">Expert retirement consulting helping you retire with confidence and peace of mind.</p>
      </div>
      <div>
        <h4 className="font-display text-orange-400 text-sm uppercase tracking-[0.2em] mb-4">Explore</h4>
        <ul className="space-y-2.5">
          {LINKS.map(([label, to]) => (
            <li key={to}><Link to={to} data-testid={`footer-link-${to.slice(1)}`} className="text-sm text-slate-300 hover:text-orange-400">{label}</Link></li>
          ))}
        </ul>
      </div>
      <div>
        <h4 className="font-display text-orange-400 text-sm uppercase tracking-[0.2em] mb-4">Call Us</h4>
        <div className="space-y-4">
          {Object.values(PHONES).map((p) => (
            <div key={p.key}>
              <p className="text-xs uppercase tracking-widest text-slate-500">{p.label}</p>
              <a href={p.tel} data-testid={`footer-phone-${p.key}`} className="text-lg font-semibold text-white hover:text-orange-400">{p.display}</a>
            </div>
          ))}
        </div>
      </div>
      <div className="space-y-5">
        <h4 className="font-display text-orange-400 text-sm uppercase tracking-[0.2em]">Connect</h4>
        <SocialLinks prefix="footer" />
        <div>
          <p className="text-xs uppercase tracking-widest text-slate-500 mb-1">Licensed States</p>
          <p className="text-sm text-slate-400 leading-relaxed">{STATES_SHORT}</p>
        </div>
      </div>
    </div>
    <StatesMarquee />
    <div className="max-w-7xl mx-auto px-5 lg:px-8 py-6 text-center space-y-2">
      <p className="text-xs text-slate-500">Not connected with or endorsed by the U.S. government or the federal Medicare program.</p>
      <p className="text-sm text-slate-400">© 2026 Zivae Financial | All Rights Reserved | Serving Clients in 19 States</p>
      <div className="flex justify-center gap-4 text-sm">
        <Link to="/terms-of-service" data-testid="footer-terms-link" className="text-orange-400 hover:text-orange-300">Terms of Service</Link>
        <span className="text-slate-600">|</span>
        <Link to="/privacy-policy" data-testid="footer-privacy-link" className="text-orange-400 hover:text-orange-300">Privacy Policy</Link>
      </div>
    </div>
  </footer>
);
